"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldLayoutBase = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../common");
const helpers_1 = require("../../../../helpers");
const styles_1 = require("../../../../helpers/styles");
const FieldLayoutErrorIcon_1 = require("../../../../icons/FieldLayoutErrorIcon");
const layouts_1 = require("../../..");
const FieldLayoutBase_styles_1 = require("./FieldLayoutBase.styles");
const getFieldLayoutSize_1 = require("../../helpers/getFieldLayoutSize");
const StackView_1 = require("../../../../StackView");
const Text_1 = require("../../../../Text");
const Tooltip_1 = require("../../../../Tooltip");
exports.FieldLayoutBase = (0, helpers_1.createUIElement)('FieldLayoutBase', (_a, ref) => {
    var { asTag, name, children, control, className, disabled, suffix, tooltipOffset, errorView = layouts_1.FIELD_ERROR_VIEW.tooltip, error, label, onLabelClick, style, helpTextWrap, helpTextView = layouts_1.FIELD_LAYOUT_HELP_TEXT_VIEW.normal, helpText, size, widthSize } = _a, rest = __rest(_a, ["asTag", "name", "children", "control", "className", "disabled", "suffix", "tooltipOffset", "errorView", "error", "label", "onLabelClick", "style", "helpTextWrap", "helpTextView", "helpText", "size", "widthSize"]);
    const { disabled: groupDisabled } = (0, layouts_1.useFormGroupContext)();
    const controlElement = (0, react_1.useMemo)(() => control || children, [children, control]);
    const isDisabled = (0, react_1.useMemo)(() => groupDisabled || disabled, [disabled, groupDisabled]);
    const hasError = (0, react_1.useMemo)(() => !isDisabled && !!error, [error, isDisabled]);
    const dataErrorAttributeValue = (0, react_1.useMemo)(() => (typeof error === 'string' ? error : ''), [error]);
    const suffixElement = (0, react_1.useMemo)(() => suffix ? (typeof suffix === 'string' ? (react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, view: isDisabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary, truncate: true }, suffix)) : (react_1.default.createElement(FieldLayoutBase_styles_1.StyledFieldLayoutBaseSuffixBox, null, react_1.default.cloneElement(suffix, { disabled: isDisabled })))) : null, [isDisabled, suffix]);
    const isTooltipActive = (0, react_1.useMemo)(() => hasError && errorView === layouts_1.FIELD_ERROR_VIEW.tooltip, [errorView, hasError]);
    const tooltipText = (0, react_1.useMemo)(() => (error && typeof error === 'string' ? error : ''), [error]);
    if (!controlElement) {
        throw new Error('FieldLayout error:  "control" or "children props is required"');
    }
    const fieldControl = (0, Tooltip_1.useTooltip)({
        tooltipOffset,
        icon: react_1.default.createElement(FieldLayoutErrorIcon_1.FieldLayoutErrorIcon, null),
        isActive: isTooltipActive,
        text: tooltipText,
        render: (control) => {
            const { disabled: elementDisabled } = controlElement.props;
            return (react_1.default.createElement(layouts_1.FormFieldControlBox, { distribution: (0, getFieldLayoutSize_1.getFieldLayoutSize)(size, widthSize) === (0, styles_1.calcWidth)(common_1.CONTROL_SIZE.full)
                    ? StackView_1.STACK_DISTRIBUTION.firstFill
                    : StackView_1.STACK_DISTRIBUTION.start },
                react_1.default.createElement(FieldLayoutBase_styles_1.StyledFieldLayoutBaseControlBoxInner, null, react_1.default.cloneElement(react_1.default.Children.only(controlElement), Object.assign({ disabled: isDisabled || elementDisabled }, control))),
                suffixElement && (react_1.default.createElement(FieldLayoutBase_styles_1.StyledFieldLayoutBaseSuffix, { collapsable: false }, suffixElement))));
        }
    });
    const dataError = (0, react_1.useMemo)(() => (hasError ? dataErrorAttributeValue : undefined), [dataErrorAttributeValue, hasError]);
    const dataDisabled = (0, react_1.useMemo)(() => (isDisabled ? '' : undefined), [isDisabled]);
    const contentTag = (0, react_1.useMemo)(() => (asTag === 'tr' ? 'td' : 'div'), [asTag]);
    return react_1.default.createElement(asTag || 'div', Object.assign(Object.assign({}, (0, helpers_1.clearProps)(rest, { ref })), { style,
        className, 'data-error': dataError, 'data-disabled': dataDisabled }), label && (react_1.default.createElement(layouts_1.Label, { disabled: isDisabled, asTag: contentTag, onClick: onLabelClick }, react_1.default.isValidElement(label)
        ? react_1.default.cloneElement(label, {
            disabled: isDisabled,
            error: hasError
        })
        : label)), react_1.default.createElement(layouts_1.FormFieldControl, { asTag: contentTag, "data-field-control-container": true },
        fieldControl,
        helpText && (isDisabled || !error || errorView !== layouts_1.FIELD_ERROR_VIEW.bottom) && (react_1.default.createElement(layouts_1.HelpText, { helpTextView: helpTextView }, helpText)),
        hasError && errorView === layouts_1.FIELD_ERROR_VIEW.bottom && (react_1.default.createElement(layouts_1.HelpText, { error: true, helpTextView: helpTextView }, error))));
});
//# sourceMappingURL=FieldLayoutBase.js.map